import React, { useEffect } from 'react';
import styled from 'styled-components';
import Hero from '../components/Hero/Hero';
import HomeContent from '../components/HomeContent/HomeContent';

const PageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

interface HomePageProps {
  isAppLoading?: boolean;
}

const HomePage: React.FC<HomePageProps> = ({ isAppLoading = false }) => {
  useEffect(() => {
    document.title = 'Radyofone - Free Radio & Music Streaming App | Arabic, English, French, Islamic';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', 'Radyofone - Stream 65+ live radio stations for free. Arabic, English, French & Islamic music from Haifa Wehbe, Amr Diab, Wael Kfoury & more. Cast to your TV. Available on iPhone, iPad, Android, Apple CarPlay & Android Auto. Download now!');
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', 'https://www.radyofone.com/');
  }, []);

  return (
    <PageContainer>
      <Hero isAppLoading={isAppLoading} />
      <HomeContent />
    </PageContainer>
  );
};

export default HomePage;
